import React from 'react'
import { connect } from 'react-redux'
import Table from 'react-bootstrap/lib/Table'
import { Fieldset } from 'tforms'
import Loading from 'bisu-react-loading'

import FormChangeItem from './form-change-item'

const FormChangeSection = ({
  isEdit,
  pending,
  onSubmit,
  onRevert,
  __items,
}) => {
  if (!__items) {
    return <Loading />
  }

  return (
    <div className="grid-form">
      <Fieldset legend="Change Section to">
        {isEdit && (
          <button onClick={onRevert} type="button" className="btn btn-warning">
            Revert Change Section Request
          </button>
        )}
        <Table condensed hover>
          <thead>
            <tr>
              <th width="10%">Subject Code</th>
              <th width="5%">Section</th>
              <th>Subject Description</th>
              <th width="18%">Schedule</th>
              <th width="5%" className="text-right">
                Units
              </th>
              <th width="15%">Instructor</th>
              <th width="5%">Slots</th>
            </tr>
          </thead>
          <tbody>
            {__items.map((item, k) => (
              <FormChangeItem
                key={k}
                item={item}
                k={k}
                onSelectItem={onSubmit}
              />
            ))}
          </tbody>
        </Table>
      </Fieldset>
    </div>
  )
}

export default connect((state, ownProps) => ({
  __items: state.cor.getIn(['changeSectionList', ownProps.itemID]),
}))(FormChangeSection)



// WEBPACK FOOTER //
// ./src/containers/COR/hocs/withChangeSection/form-change-section.js